var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","flat":"","color":"white"}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){_vm.app.drawer = !_vm.app.drawer}}}),_c('v-toolbar-title',{staticClass:"text-uppercase"},[_c('span',{staticClass:"font-weight-light primary--text"},[_vm._v("minsu")]),_c('span',{staticClass:"primary--text"},[_vm._v("app")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }